import { gql } from 'graphql-request'

export const ManyGuestsQuery = gql`
  query AllGuests(
    $page: Int = 1
    $limit: Int = 200
    $locale: LocaleInputType!
    $where: Guest_where_and = {}
  ) {
    Guests(
      page: $page
      limit: $limit
      locale: $locale
      sort: "-dateStart,-dateEnd"
      where: { AND: [{ _status: { equals: published } }, $where] }
    ) {
      docs {
        id
        title
        dateStart
        dateEnd
        people {
          id
          firstName
          lastName
          isExternal
          person {
            id
            slug
            title
            sortValue
          }
        }
      }
      totalDocs
      hasNextPage
    }
  }
`

export const ManyCurrentGuestsQuery = gql`
  query AllCurrentGuests(
    $locale: LocaleInputType!
    $where: Guest_where_and = {}
    $isPreview: Boolean! = false
    $statuses: [Guest__status_Input] = [published]
  ) {
    Guests(
      draft: $isPreview
      locale: $locale
      where: { AND: [{ _status: { in: $statuses } }, $where] }
    ) {
      docs {
        id
        title
        dateStart
        dateEnd
        people {
          id
          firstName
          lastName
          isExternal
          person {
            id
            slug
            title
            sortValue
          }
        }
      }
      totalDocs
      hasNextPage
    }
  }
`
